// extracted by mini-css-extract-plugin
export default {"btnFlutuante":"btnFlutuante_btnFlutuante__qdVd-"};